import { Base, withBreakpointObserver } from '@studiometa/js-toolkit';
import MenuItem from './MenuItem.js';

/**
 * Toast component
 */
export default class Menu extends withBreakpointObserver(Base) {
  menuItemOpen = false;
  isOpen = false;

  /**
   * Component Configuration
   */
  static config = {
    name: 'Menu',
    refs: ['close[]'],
    components: {
      MenuItem,
    },
    options: {
      activeBreakpoints: {
        type: String,
        default: 'xxs xs s',
      },
    },
  };

  /**
   *
   */
  toggleMenu() {
    if (this.isOpen) {
      this.closeMenu();
    } else {
      this.openMenu();
    }
  }

  /**
   * Close when press Escape key
   * @param  {object} options key
   * @param  {object} options.ESC key
   * @returns {void}
   */
  keyed({ ESC }) {
    if (ESC) {
      this.closeMenu();
    }
  }

  /**
   *
   */
  openMenu() {
    this.isOpen = true;
    document.body.classList.add('is-menu-open');
  }

  /**
   *
   */
  closeMenu() {
    this.isOpen = false;
    document.body.classList.remove('is-menu-open');
    if (this.menuItemOpen) {
      this.closeAllmenuItems();
    }
  }

  /**
   *
   */
  onCloseclick() {
    this.closeMenu();
  }

  /**
   * Close all menuItem when closing Menu
   * @returns {void}
   */
  closeAllmenuItems() {
    this.$children.MenuItem.forEach((element) => {
      element.closeSubmenu();
    });
  }
}
